/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AccountSelectorSpokeSearchQueryVariables = {
    search: string;
};
export type AccountSelectorSpokeSearchQueryResponse = {
    readonly viewer: {
        readonly spokeSearch: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly name: string;
                    readonly account: string;
                    readonly hub: {
                        readonly name: string;
                        readonly account: string;
                    };
                } | null;
            } | null> | null;
        } | null;
    };
};
export type AccountSelectorSpokeSearchQuery = {
    readonly response: AccountSelectorSpokeSearchQueryResponse;
    readonly variables: AccountSelectorSpokeSearchQueryVariables;
};



/*
query AccountSelectorSpokeSearchQuery(
  $search: String!
) {
  viewer {
    spokeSearch(search: $search) {
      edges {
        node {
          name
          account
          hub {
            name
            account
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
          }
        ],
        "concreteType": "SearchSpokeConnection",
        "kind": "LinkedField",
        "name": "spokeSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchSpokeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchSpoke",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchSpoke",
                    "kind": "LinkedField",
                    "name": "hub",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSelectorSpokeSearchQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSelectorSpokeSearchQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9d40155b8b16f0c0f1df5ec3a5be9c98",
    "id": null,
    "metadata": {},
    "name": "AccountSelectorSpokeSearchQuery",
    "operationKind": "query",
    "text": "query AccountSelectorSpokeSearchQuery(\n  $search: String!\n) {\n  viewer {\n    spokeSearch(search: $search) {\n      edges {\n        node {\n          name\n          account\n          hub {\n            name\n            account\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '278d0e91255b0302fb2cf8825343cfb5';
export default node;
